export const styles = {
  container: {
    marginTop: '16px',
    padding: '20px',
    borderRadius: '4px',
    textAlign: 'center',
    cursor: 'pointer',
  },
  button: {
    padding: '10px 20px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px',
    marginTop: '10px',
  },
};
